import React from 'react';

interface EmptyRowProps {
  text: string;
  colSpan: number;
}

const EmptyRow: React.FC<EmptyRowProps> = ({ text, colSpan }) => {
  return (
    <tr className="odd">
      <td valign="top" colSpan={colSpan} className="dataTables_empty">
        {text}
      </td>
    </tr>
  );
};

export default EmptyRow;
